import AProvider from "src/framework/providers/AProvider";
import api, { IDataRequest, IDataResponse } from "src/framework/providers/api";
import { ProjetosDescontosRequest } from "./types";

class ProjetosDescontosProvider extends AProvider {
    constructor() {
        super("/projetos/descontos");
    }

    async consultarDescontos(id_projeto: number): Promise<IDataResponse> {
        try {
            const request: IDataRequest = {
                url: `/projetos/descontos/consultar/${id_projeto}`,
            }

            return await api.get(request);
        } catch (error) {
            return {
                data: null,
                message: "Erro ao consultar descontos",
                statusCode: 404
            }
        }
    }

    async atualizarDescontos(id_projeto: number, projetoDescontos: ProjetosDescontosRequest): Promise<IDataResponse> {
        try {
            const request: IDataRequest = {
                url: `/projetos/descontos/atualizar/${id_projeto}`,
                data: projetoDescontos
            }

            return await api.put(request);
        } catch (error) {
            return {
                data: null,
                message: "Erro ao atualizar descontos",
                statusCode: 404
            }
        }
    }
}

export { ProjetosDescontosProvider }